export type ComponentBreakpoint = 'desktop' | 'tablet';

export const tableHeadMovement = {
  requestDate: 'Data de solicitação',
  settlementDate: 'Data de liquidação',
  description: 'Descrição',
  value: 'Valor(R$)',
  asset: 'Ativo',
  status: 'Status',
  cancellation: 'Cancelamento',
};

export const movementWidthCols: Record<movementRecords, { [K in ComponentBreakpoint]: number }> = {
  requestDate: { desktop: 15, tablet: 15 },
  settlementDate: { desktop: 15, tablet: 15 },
  description: { desktop: 15, tablet: 15 },
  value: { desktop: 15, tablet: 15 },
  asset: { desktop: 15, tablet: 15 },
  status: { desktop: 15, tablet: 15 },
  cancellation: { desktop: 10, tablet: 10 },
};

type movementRecords = keyof typeof tableHeadMovement;

export const tableHeadAlignments: Partial<Record<movementRecords, 'left' | 'center' | 'right'>> =
  {};
